import React from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { PhoneNumber } from '../FormFields/PhoneNumber';

export const EmergencyContactInfo = ({
	id,
	value,
	register,
	unregister = () => {},
	handleRemove = () => {},
	enableRemove = false,
	error,
}) => {
	return (
		<>
			<Row>
				<Form.Group as={Col} xs="12" md="6">
					<Form.Label>Contact Name</Form.Label>
					<Form.Control
						type="text"
						{...register(`contacts[${id}].contactName`)}
					/>
					<Form.Text className="text-danger">
						{error.contacts?.[id]?.contactName?.message}
					</Form.Text>
				</Form.Group>
				<Form.Group as={Col} xs="12" md="6">
					<Form.Label>Relationship</Form.Label>
					<Form.Control
						type="text"
						{...register(`contacts[${id}].relationship`)}
					/>
					<Form.Text className="text-danger">
						{error.contacts?.[id]?.relationship?.message}
					</Form.Text>
				</Form.Group>
			</Row>
			<Row>
				<Form.Group as={Col} xs="12" md="6">
					<Form.Label>Cell Phone</Form.Label>
					<PhoneNumber
						register={register}
						registerName={`contacts[${id}].cellPhone`}
					/>
					<Form.Text className="text-danger">
						{error.contacts?.[id]?.cellPhone?.message}
					</Form.Text>
				</Form.Group>
				<Form.Group as={Col} xs="12" md={enableRemove === true ? '5' : '6'}>
					<Form.Label>
						Office Phone <small className="text-secondary">(optional)</small>
					</Form.Label>
					<PhoneNumber
						register={register}
						registerName={`contacts[${id}].officePhone`}
					/>
					<Form.Text className="text-danger">
						{error.contacts?.[id]?.officePhone?.message}
					</Form.Text>
				</Form.Group>
				{enableRemove === true && (
					<Button
						variant="outline-danger"
						className="deleteButton"
						onClick={() => {
							handleRemove(id);
							unregister(`contacts[${id}]`);
						}}>
						Remove Contact
					</Button>
				)}
			</Row>
		</>
	);
};
